import React from 'react';
import Search from './Search';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';

function Index(props) {
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  return (
    <Search location={location} history={history} match={match} {...props} />
  );
}

export default Index;
